const PAGE_HEADER_ACTIONS_DISPLAY_NAME = 'PageHeader.Actions';
const ACTIONS_BUTTON_SIZE_MAP = {
  l1: 'md',
  l2: 'sm'
};

export { ACTIONS_BUTTON_SIZE_MAP, PAGE_HEADER_ACTIONS_DISPLAY_NAME };
